import { BmHttp } from "../utils/Global"


export const ListarPacientes = async (idclinica) => {
    try {
        const { data } = await BmHttp().get(`listar_paciente?idclinica=${idclinica}`)
        return data
    } catch (error) {
        console.log(error)
    }
}

export const RegistrarPaciente = async (datos) => {
    try {
        if(datos.idpaciente > 0){
            return ActualizarPaciente(datos)
        }else{
            const { data } = await BmHttp().post(`crear_paciente`, datos)
            return data
        }
    } catch (error) {
        console.log(error)
    }
}

export const ActualizarPaciente = async (datos) => {
    try {
        const { data } = await BmHttp().put(`actualizar_paciente`, datos)
        return data
    } catch (error) {
        console.log(error)
    }
}

export const EliminarPaciente = async (idpaciente) => {
    try {
        const { data } = await BmHttp().delete(`eliminar_paciente?idpaciente=${idpaciente}`)
        return data
    } catch (error) {
        console.log(error)
    }
}

export const ControllerListarPacientesCitas = async (idpaciente) => {
    try {
        const { data } = await BmHttp().get(`listar_paciente_ultimas_citas?idpaciente=${idpaciente}`)
        return data
    } catch (error) {
        console.log(error);
    }
}

export const ListarPacienteCitasHistorial = async ({ idpaciente, page = 1, limit = 10, search = "" }) => {
    try {
        const { data } = await BmHttp().get(`listar_paciente_citas_historial`, {
            params: { idpaciente, page, limit, search: search || undefined }
        })
        return data
    } catch (error) {
        return {
            success: false,
            message: error?.response?.data?.message || error?.message || "Error desconocido",
            data: [],
            pagination: { total: 0, page, limit, pages: 0 }
        }
    }
}


export const GetPacientesAll = async(page, limit, search) => {
    try {
      const { data } = await BmHttp().get(`pacientes`, {params: {page, limit, search }});
      return data;
        
    } catch (error) {
        return error.response.data;
    }
  }